import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import PublicLayout from "web/components/PublicLayout";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import DigitalSupplier from "../../../../assets/images/1ManagedServices.svg";
import GetIcon1 from "../../../../assets/images/1get.svg";
import GetIcon2 from "../../../../assets/images/2get.svg";
import GetIcon3 from "../../../../assets/images/3get.svg";
import GetIcon4 from "../../../../assets/images/4get.svg";
import tickIcon from "../../../../assets/images/tickIcon34.svg";
import crossIcon from "../../../../assets/images/crossIcon34.svg";
import ButtonSet from "../ButtonSet";
import {
  Container,
  Wrapper,
  ColorBox,
} from "web/pages/public/landing-page/ManagedServices/ManagedServicesStyled";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const data = [
  {
    title: ["Centralized", "Management"],
    icon: GetIcon1,
    description: [
      "Seamless Order Management",
      "Real-Time Order Tracking",
      "Invoice & Document Repository",
    ],
  },
  {
    title: ["Network", "Visibility"],
    icon: GetIcon2,
    description: [
      "One Portal, Unlimited User Access",
      "Real-Time Location/Network Visibility",
      "On-Demand KPIs & Customized Reporting",
    ],
  },
  {
    title: ["Flexible Pricing & Terms"],
    icon: GetIcon3,
    description: ["Market Transparency", "Flexible Pricing Models"],
  },
  {
    title: ["Expert", "Resources"],
    icon: GetIcon4,
    description: ["Dedicated Account Reps", "Expert QC Team"],
  },
];


const CardDetails = ({ item, index, isOpen, onOpen, onClose }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClose]);

  return (
    <div className="card" data-aos="fade-right" data-aos-delay={index * 300} ref={ref}>
      <div className="text-box">
        <h4>
          {Array.isArray(item?.title) ? (
            item.title.map((line, idx) => (
              <React.Fragment key={idx}>
                {line}
                {idx < item.title.length - 1 && <br />}
              </React.Fragment>
            ))
          ) : (
            item?.title
          )}
        </h4>
        <p onClick={onOpen}>Read more</p>
        <div className={`hover-box ${isOpen ? 'active' : ''}`}>
          <img src={crossIcon} onClick={onClose} alt="close icon" />
          <h4>
            {Array.isArray(item?.title) ? (
              item.title.map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < item.title.length - 1 && <br />}
                </React.Fragment>
              ))
            ) : (
              item?.title
            )}
          </h4>
          <ul>
            {item?.description?.map((desc, descIndex) => (
              <li key={index + "description-" + descIndex}>
                <img src={tickIcon} alt="tick icon" /> {desc}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="img-box">
        {typeof item.icon === "function" ? (
          item.icon()
        ) : (
          <img src={item.icon} alt="icon" />
        )}
      </div>
    </div>
  );
};


CardDetails.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

const ManagedServices = () => {
  const location = useLocation();
  const whatRef = useRef(null);
  const ourRef = useRef(null);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash === "#what") {
      if (whatRef.current) {
        // whatRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = whatRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#our") {
      if (ourRef.current) {
        // ourRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = ourRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  let history = useHistory();
  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => {
    setOpenIndex(index);
  };

  const handleClose = () => {
    setOpenIndex(null);
  };

  return (
    <>
      <Helmet title="PalletTrader | Managed Services">
        <meta
          name="description"
          content="Simplify your pallet management with PalletTrader’s managed solutions for buyers. Let our experts handle sourcing, negotiating, and securing pallets for your needs."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/managed-services" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <section className="our_expertise suppliers mb-0">
              <div className="expertise_overlay managed">
                <div data-aos="fade-right" data-aos-delay="100">
                  <h2>Managed</h2>
                  <h2>Services</h2>
                </div>
              </div>
            </section>
            <section className="pallet_faq">
              <div className="faq-head">
                <h2>We Do the Work. You Get The Assurance.</h2>
                <p>
                  Our end-to-end managed services through PalletTrader+ ensure
                  smooth and efficient pallet management for any size operation.
                  Focus on your core business while we take care of the rest.
                </p>
              </div>
            </section>
            <section className="digital_supplier">
              <div className="digital_supplier_img">
                <img
                  src={DigitalSupplier}
                  alt="icon"
                  data-aos="fade-down"
                  data-aos-delay="100"
                />
              </div>
              <div className="digital_supplier-text">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h2>Industry-Leading Technology + Dedicated Experts.</h2>
                  <p>
                    PalletTrader+ provides a custom management portal that
                    maximizes visibility, efficiency, and control across your
                    network. Users have on demand access to request, manage and
                    track orders, view real time KPIs and download all paperwork
                    and invoices, from one centralized platform.
                  </p>
                </div>
              </div>
            </section>

            <div className="what_you_get" id="how" ref={whatRef}>
              <div className="what_you_get-container">
                <h2>What you get.</h2>
                {/* <p>All the Tools. All the Technology. It's All You Need</p> */}

                <div className="cards-container">
                  {data?.map((item, index) => (
                    <CardDetails
                      key={"card-item" + index}
                      item={item}
                      index={index}
                      isOpen={openIndex === index}
                      onOpen={() => handleOpen(index)}
                      onClose={handleClose}
                    />
                  ))}
                </div>
              </div>
            </div>



            <section className="pallet_faq" id="our" ref={ourRef}>
              <div className="faq-head">
                <h2 className="our">Our Specialties.</h2>
                <p>
                  Flexible solutions, built through collaboration and designed
                  to scale, or flex, with all your pallet business needs.
                </p>
              </div>
            </section>
            <section className="color_box_wrp mb-0">
              <ColorBox data-aos="flip-up" data-aos-delay="000">
                <div className="color_head blue">
                  <h4>Network Procurement & Order Management</h4>
                </div>
                <div className="color_body gry">
                  <p>
                    We will price, supply, and manage all your pallet needs,
                    from RFP, to order tender and delivery, leveraging our online
                    network of vetted pallet suppliers. Our expert team of
                    operators and quality control specialists will guarantee the
                    most quality pallets at the best cost possible meeting your
                    on time delivery requirements.
                  </p>
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head sky">
                  <h4>Routing Guide Execution</h4>
                </div>
                <div className="color_body light_sky">
                  <p>
                    Have reliable incumbent partners but are tired of fragmented
                    processes and limited visibility? Let our platform be the
                    engine that streamlines and centralizes all of your order
                    management. We execute your preset supplier agreements, and
                    take care of the load tender, tracking and audit processes.
                    You get end-to-end order visibility with unlimited user
                    access and on demand KPIs.
                  </p>
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head ocean">
                  <h4>Buyback & Sell-Off Programs</h4>
                </div>
                <div className="color_body gry">
                  <p>
                    Our team of experts will perform a network assessment to
                    determine the most optimal supply & return program design,
                    resulting in the lowest total cost of ownership (TCO). You
                    can monitor all of your purchases and sell offs from our
                    centralized portal for ultimate net cost visibility and
                    landfill avoidance KPIs.
                  </p>
                </div>
              </ColorBox>
            </section>
            <section className="pallet_faq">
              <div className="faq-head">
                <h2 className="market">Meet the Team. Request a Quote.</h2>
                <h2 className="market">Experience Innovation.</h2>
                <ButtonSet />
              </div>
            </section>
          </Wrapper>
        </Container>
        <LandingFooter />
      </PublicLayout>
    </>
  );
};

export default ManagedServices;
